import { render, staticRenderFns } from "./StatisticsMarksTimeFacultyIndex.vue?vue&type=template&id=c002b492"
import script from "./StatisticsMarksTimeFacultyIndex.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksTimeFacultyIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports